// Import the Patientv2 interface
import React from 'react';
import { Grid2 } from '@mui/material';
import { Patientv2 } from '../../../types';
import { getDateInDDMMYYYY, toTitleCase } from '../../../utils/commonUtils';

interface PatientDetailsProps {
  selectedPatientDetails: Patientv2; // Use Patientv2 interface
}

const PatientDetails: React.FC<PatientDetailsProps> = ({ selectedPatientDetails }) => (
  <>
    <Grid2 container spacing={2} mx={1} my={1} pl={2} width={'100%'}>
      <Grid2 size={{xs: 3, lg:3}}>
        <strong>First Name</strong>
        <div>{selectedPatientDetails.first_name}</div>
      </Grid2>

      <Grid2 size={{xs: 3, lg:3}}>
        <strong>Last Name</strong>
        <div>{selectedPatientDetails.last_name}</div>
      </Grid2>

      <Grid2 size={{xs: 3}}>
        <strong>DOB</strong>
        <div>{getDateInDDMMYYYY(selectedPatientDetails.date_of_birth)}</div>
      </Grid2>

      <Grid2 size={{xs: 3}}>
        <strong>Sex Assigned At Birth</strong>
        <div>{toTitleCase(selectedPatientDetails.gender)}</div>
      </Grid2>

      <Grid2 size={{xs: 3}}>
        <strong>MRN</strong>
        <div>{selectedPatientDetails.medical_record_no || 'N/A'}</div> {/* Display 'N/A' if null */}
      </Grid2>

      <Grid2 size={{xs: 3}}>
        <strong>Mobile Number</strong>
        <div>{selectedPatientDetails.mobile_number_country_code && selectedPatientDetails.mobile_number ? `${selectedPatientDetails.mobile_number_country_code}-${selectedPatientDetails.mobile_number}` : `+00-0000000000`}</div>
      </Grid2>

      <Grid2 size={{xs: 3}}>
        <strong>Email ID</strong>
        <div>{selectedPatientDetails?.alternate_email || ''}</div>
      </Grid2>
    </Grid2>

    {selectedPatientDetails.partner && ( // Check if partner details exist
      <Grid2 container spacing={2} mx={1} my={1} pl={2} width={'100%'}>
        <Grid2 size={{xs: 3}}>
          <strong>Partner First Name</strong>
          <div>{selectedPatientDetails.partner.first_name}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>Partner Last Name</strong>
          <div>{selectedPatientDetails.partner.last_name}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>Partner DOB</strong>
          <div>{getDateInDDMMYYYY(selectedPatientDetails.partner.date_of_birth)}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>Sex Assigned At Birth</strong>
          <div>{toTitleCase(selectedPatientDetails.partner.gender)}</div>
        </Grid2>
      </Grid2>
    )}
  </>
);

export default PatientDetails;
